import React, { useEffect, useState } from 'react';
import { FaMobileAlt, FaUser, FaEnvelope, FaKey } from "react-icons/fa";
import Header from '../../includes/Header';
import Loader from '../../components/Loader/Loader';
import { Container, Row, Col } from 'react-bootstrap';

import { getProfile, postProfile, postSendOtp } from '../../apiservices/ApiServices';

import { useFormik } from 'formik';
import { profileSchema } from '../../schemas';

import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";

import EditBtn from '../../assets/images/edit_btn.png';
import userImg from '../../assets/images/users.png';

const Profile = () => {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [otpRequested, setOtpRequested] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [isImgeChange, setImgeChange] = useState(false);

    const navigate = useNavigate();

    const getProfiles = async () => {
        try {
            const res = await getProfile();
            setData(res.data.data);
            localStorage.setItem('useData', JSON.stringify(res.data.data));
            if (res.data.data?.image != null) {
                setPreviewImage(res.data.data?.image)
                setImgeChange(false);
            }
            else {
                setPreviewImage(userImg);
                setImgeChange(true);
            }

            setLoading(false);
        } catch (error) {
            console.log(error.response.data.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        setOtpRequested(false);
        if (!localStorage.getItem('useToken')) {
            navigate("/");
        }
        else {
            getProfiles();
        }
    }, [])

    const handleProfile = async (values) => {
        setLoading(true);
        const formData = new FormData();
        if (isImgeChange) {
            formData.append("image", values.image);
        }
        formData.append("ContactNo", values.mobile);

        try {
            const res = await postProfile(formData);
            toast.success(res.data.message);
            getProfiles();
            setLoading(false);
            setOtpRequested(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response.data.message);
        }
    };

    const formik = useFormik({
        enableReinitialize: true, // Ensures form values update when data changes
        initialValues: {
            image: data?.image || '',
            roleID: data?.role?.RoleID || '',
            roleName: data?.role?.RoleName || '',
            name: data?.Name || '',
            email: data?.email || '',
            mobile: data?.ContactNo || '',
            otp: '',
        },
        validationSchema: profileSchema(otpRequested),
        onSubmit: (values) => {
            handleProfile(values);
            console.log(values);
        }
    });

    const { values, errors, touched, handleBlur, handleChange, setFieldValue, handleSubmit } = formik;

    const handleSendOtp = async (mobile) => {
        let postdata =
        {
            "ContactNo": mobile,
        }
        try {
            const res = await postSendOtp(postdata);
            toast.success(res.data.message);
            setOtpRequested(true);
        } catch (error) {
            setOtpRequested(false);
            toast.error(error.response.data.message);
        }
    };

    return (
        <>
            <Header data={data} />
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            <section id='auth'>
                <div className='users-block'>
                    <Container>
                        <div className='users-box'>
                            <div className='titles-box'>
                                <h4>Profile</h4>
                                <Link to={'/change-password'} className='btn btn-orange'><FaKey /> Change Password</Link>
                            </div>
                            <div className='forms'>
                                <form id='profile' onSubmit={handleSubmit} autoComplete="off">
                                    <Row>
                                        <Col md={12}>
                                            <div className="file_upload_box">
                                                <div className="upload_btn">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(event) => {
                                                            const file = event.currentTarget.files[0];
                                                            setImgeChange(true);
                                                            setFieldValue('image', file);
                                                            if (file) {
                                                                setPreviewImage(URL.createObjectURL(file));
                                                            }
                                                        }}
                                                    />
                                                    <div className="edit_btn">
                                                        <img src={EditBtn} alt='Edit Image' title='Edit Image' />
                                                    </div>
                                                </div>
                                                {previewImage && (
                                                    <div className="selected_img">
                                                        <img src={previewImage} alt='' title='' />
                                                    </div>
                                                )}
                                                {errors.image && touched.image ? (
                                                    <p className='errormsg'>{errors.image}</p>
                                                ) : null}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='form-group'>
                                                <div className="control has-icon">
                                                    <label className="label auth-label" htmlFor="name">Name</label>
                                                    <input type="text"
                                                        id="name"
                                                        name="name"
                                                        className="input v-input"
                                                        autoComplete='off'
                                                        value={values.name}
                                                        readOnly={true}
                                                    />
                                                    <label className="label form-icon" htmlFor="name">
                                                        <FaUser />
                                                    </label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='form-group'>
                                                <div className="control has-icon">
                                                    <label className="label auth-label" htmlFor="email">Email Address.</label>
                                                    <input type="email"
                                                        id="email"
                                                        name="email"
                                                        className="input v-input"
                                                        autoComplete='off'
                                                        value={values.email}
                                                        readOnly={true}
                                                    />
                                                    <label className="label form-icon" htmlFor="mobile">
                                                        <FaEnvelope />
                                                    </label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='form-group'>
                                                <div className="control has-icon">
                                                    <label className="label auth-label" htmlFor="roleID">Role ID</label>
                                                    <input type="roleID"
                                                        id="roleID"
                                                        name="roleID"
                                                        className="input v-input"
                                                        autoComplete='off'
                                                        value={values.roleID}
                                                        readOnly={true}
                                                    />
                                                    <label className="label form-icon" htmlFor="mobile">
                                                        <FaEnvelope />
                                                    </label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='form-group'>
                                                <div className="control has-icon">
                                                    <label className="label auth-label" htmlFor="roleName">Role Name</label>
                                                    <input type="roleName"
                                                        id="roleName"
                                                        name="roleName"
                                                        className="input v-input"
                                                        autoComplete='off'
                                                        value={values.roleName}
                                                        readOnly={true}
                                                    />
                                                    <label className="label form-icon" htmlFor="mobile">
                                                        <FaEnvelope />
                                                    </label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='form-group'>
                                                <div className="control has-icon">
                                                    <label className="label auth-label" htmlFor="mobile">Mobile No.</label>
                                                    <input
                                                        type="tel"
                                                        id="mobile"
                                                        name="mobile"
                                                        className="input v-input"
                                                        autoComplete='off'
                                                        value={values.mobile}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors.mobile && touched.mobile ? (
                                                        <p className='errormsg'>{errors.mobile}</p>
                                                    ) : null}
                                                    <label className="label form-icon" htmlFor="mobile">
                                                        <FaMobileAlt />
                                                    </label>
                                                    {values.mobile !== data?.ContactNo && !errors.mobile && !otpRequested && (
                                                        <div className='otpbutton'>
                                                            <button type="button" className="btn btn-link" onClick={() => handleSendOtp(values.mobile)}>Get OTP</button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                        {otpRequested ?
                                            <Col md={6}>
                                                <div className='form-group'>
                                                    <div className="control has-icon">
                                                        <label className="label auth-label" htmlFor="mobile">OTP.</label>
                                                        <input type="text"
                                                            id="otp"
                                                            name="otp"
                                                            className="input v-input"
                                                            autoComplete='off'
                                                            value={values.otp}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.otp && touched.otp ? (
                                                            <p className='errormsg'>{errors.otp}</p>
                                                        ) : null}
                                                        <label className="label form-icon" htmlFor="otp">
                                                            <FaMobileAlt />
                                                        </label>
                                                    </div>
                                                </div>
                                            </Col> : null}

                                        <Col md={12}>
                                            <div className='buttonbox'>
                                                <button type='submit' className='btn btn-green'>Submit</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>
            {isLoading ? <Loader /> : null}
        </>
    )
}

export default Profile;